module.exports = __webpack_public_path__ + "media/music.e30362f8.mp3";